import React, { useState, useEffect } from 'react';
import { ShieldCheck, X } from 'lucide-react';

import PrivacyPolicyModal from './PrivacyPolicyModal';

const CookieConsent: React.FC = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('@ZapShop:cookieConsent');
        if (!consent) {
            const timer = setTimeout(() => setIsVisible(true), 1500);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('@ZapShop:cookieConsent', 'true');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <>
            <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-8 md:max-w-md z-[100] animate-slide-up">
                <div className="bg-white/80 backdrop-blur-xl border border-white/20 shadow-[0_20px_50px_rgba(0,0,0,0.15)] rounded-3xl p-5 md:p-6 overflow-hidden relative group">
                    {/* Glow effect */}
                    <div className="absolute -top-10 -right-10 w-32 h-32 bg-brand-500/10 rounded-full blur-3xl pointer-events-none group-hover:bg-brand-500/20 transition-all duration-700"></div>

                    <div className="flex items-start gap-4">
                        <div className="shrink-0 w-12 h-12 bg-brand-50 rounded-2xl flex items-center justify-center text-brand-600 shadow-inner border border-brand-100/50">
                            <ShieldCheck size={26} />
                        </div>

                        <div className="flex-1 pr-6">
                            <h4 className="text-sm font-black text-surface-900 uppercase tracking-wider mb-1 flex items-center gap-2">
                                Privacidade & Cookies
                            </h4>
                            <p className="text-xs text-surface-500 leading-relaxed font-medium">
                                Utilizamos cookies para melhorar sua experiência e analisar nosso tráfego conforme a LGPD. Ao continuar, você concorda com nossos termos.
                            </p>
                        </div>

                        <button
                            onClick={() => setIsVisible(false)}
                            className="absolute top-4 right-4 p-1 rounded-full hover:bg-surface-100 text-surface-400 transition-colors"
                        >
                            <X size={18} />
                        </button>
                    </div>

                    <div className="mt-5 flex gap-3">
                        <button
                            onClick={handleAccept}
                            className="flex-1 bg-brand-600 hover:bg-brand-700 text-white text-xs font-black uppercase tracking-widest py-3 rounded-xl transition-all shadow-lg shadow-brand-600/20 active:scale-95"
                        >
                            Aceitar e Continuar
                        </button>
                        <button
                            onClick={() => setIsModalOpen(true)}
                            className="px-4 flex items-center justify-center bg-surface-50 hover:bg-surface-100 text-surface-500 text-[10px] font-bold uppercase tracking-widest rounded-xl transition-all"
                        >
                            Ver Política
                        </button>
                    </div>
                </div>
            </div>

            <PrivacyPolicyModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
            />
        </>
    );
};

export default CookieConsent;
